import { render } from "./RememberPayment.vue?vue&type=template&id=7b436f04"
import script from "./RememberPayment.vue?vue&type=script&lang=js"
export * from "./RememberPayment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__